module.exports = __webpack_public_path__ + "static/media/suche.16a921ea.svg";